<template>
    <div>
        <sys-select-base 
            :model.sync="selected"
            :items="items"
            :loading="loading"
            :label="label"
            :error="error"
            :errors="errors"
            @onShowForm="showForm = true"
            :clearable="clearable"
            :showAdd="showAdd"
            :multiple="multiple"
            :dense="dense"
            :disabled="disabled"
            :selectAll="selectAll"
            :autoComplete="autoComplete"
            @change="$emit('change', $event)"
        >
            <template v-if="showSlotItem" v-slot:dataItem="{ item }">
                {{ item.name }}
            </template>
        </sys-select-base>
     
    </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'

export default {
    name: 'SysSelectInstitution',
    data: () => ({
        items: [],
        loading: false,
        selected: null,
        showForm: false
    }),
    computed: {
        ...mapState('auth', ['acesso'])
    },
    mounted(){
        
    },
    created() {
        this.getItems();
    },
    props: {
        
        error: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Array,
        },
        label: {
            type: String,
            required: true
        },
        clearable: {
            type: Boolean,
            default: false
        },
        showAdd: {
            type: Boolean,
            default: false
        },
        model: {
        
        },
        multiple: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        },
        showSlotItem: {
            type: Boolean,
            default: false
        },
        dense: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        selectAll: {
            type: Boolean,
            default: false
        },
        autoComplete: {
            type: Boolean,
            default: false
        },
        brandId: {

        }
        
    },
    watch: {
        
        selected(val){
            this.$emit('update:model', val);
        },
        
        model(val){
            this.selected = val;
        },

        brandId(){
            this.getItems();
        },
    },
    methods: {
        ...mapActions('institution', ['ActionIndexAllInstitutions']),        
        
        async getItems() {

            this.loading = true;
            let payload = {};

            if(this.brandId){
                
                if(!payload.find_columns){
                    payload.find_columns = {};
                }

                payload.find_columns.brand_id = this.brandId;
            }

            await this.ActionIndexAllInstitutions(payload)
                    .then((res) => {
                        this.items = res.data;
                        this.selected = this.model;
                        
                        if(this.required && !this.model && this.items.length == 1){
                            
                            if(this.multiple){
                                this.selected = [this.items[0]];
                            }else{
                                this.selected = this.items[0];
                            }
                            
                        }

                        this.$emit('loaded', this.items);

                    })
                    .finally(() => {
                        this.loading = false;
                    })
        },

    newItem(item){
            
            if(item){
                this.items.push(item);
                this.selected = item.id;
                this.showForm = false;
            }
        }
    },
    
}
</script>